module.exports = __webpack_public_path__ + "img/galactica_blueprints_14.38ac0257.png";